/* 1) Bolinhas (dots) para os sliders de USP em mobile */
(function () {
  var MQ = '(max-width: 749px)';

  function buildDots(grid) {
    if (grid.dataset.joDots === '1') return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('grid-item');
    });
    if (items.length < 2) return;
    grid.dataset.joDots = '1';

    var dots = document.createElement('div');
    dots.className = 'jo-dots';

    items.forEach(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'jo-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Item ' + (i + 1));
      dot.addEventListener('click', function () {
        grid.scrollTo({ left: item.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    grid.parentNode.insertBefore(dots, grid.nextSibling);

    var timer;
    grid.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var best = Infinity;
        var index = 0;
        items.forEach(function (item, i) {
          var delta = Math.abs(item.offsetLeft - grid.offsetLeft - grid.scrollLeft);
          if (delta < best) { best = delta; index = i; }
        });
        Array.prototype.slice.call(dots.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }, 60);
    }, { passive: true });
  }

  function init() {
    if (window.matchMedia && !window.matchMedia(MQ).matches) return;
    document.querySelectorAll('.grid.multicolumn').forEach(buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  window.addEventListener('resize', function () { setTimeout(init, 200); });
})();

/* 2) Aviso de stock baixo igual ao da Charlotte Bath */
(function () {
  function build() {
    var wraps = document.querySelectorAll('.form__width');
    for (var w = 0; w < wraps.length; w++) {
      var kids = wraps[w].children;
      var pill = null;
      for (var i = 0; i < kids.length; i++) {
        var st = kids[i].getAttribute ? kids[i].getAttribute('style') : null;
        if (st && st.indexOf('#fde8e8') > -1) { pill = kids[i]; break; }
      }
      if (!pill || pill.dataset.joLow === '1') continue;
      pill.dataset.joLow = '1';

      var box = document.createElement('div');
      box.className = 'jo-lowstock';
      box.innerHTML =
        '<span class="jo-lowstock__icon">' +
        '<span class="jo-lowstock__dot jo-lowstock__dot--pulse"></span>' +
        '<span class="jo-lowstock__dot"></span>' +
        '</span>' +
        '<span class="jo-lowstock__text">Low stock - few pieces left</span>';
      pill.parentNode.insertBefore(box, pill);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);
  setTimeout(build, 1200);
})();
